import { Accordion, AccordionDetails, AccordionSummary, Box, LinearProgress, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { BasePathProvider } from 'components/Providers'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const baseUrl = '/admin-evaluation/indicator-list'

export default function IndicatorListPage({ adminStandards }) {
    const filteredStandards = adminStandards?.filter(standard => standard.type === 1) 

    const [expanded, setExpanded] = useState('panel1');
    const { t } = useTranslation();

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : 1);
    };

    if (!adminStandards) return <LinearProgress />

    return (
        <Box component={Paper} sx={{ width: '100%', p: 1, mb: 2 }}>
            <BasePathProvider value={`${baseUrl}`}>
                <Box px={1} py={2} display="flex" gap={1} >
                    <Box width={'100%'}>
                        {filteredStandards.map((standard, index) => (
                            <Accordion 
                                key={index}
                                expanded={expanded === `panel${index + 1}`}
                                onChange={handleChange(`panel${index + 1}`)}
                                aria-controls="panel-content"
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Box sx={{ display: 'flex', paddingY: '3px', paddingX: '10px', borderRadius: '100px', backgroundColor: 'primary.main', color: 'white', fontSize: '0.8rem', fontWeight: 'bold' }}>
                                            <Typography variant='body1'>PS {standard.id}.</Typography>
                                        </Box>
                                        <Box>
                                            {standard.name.split(':')[1]}
                                        </Box>
                                    </Stack>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <TableContainer>
                                        <Table sx={{ minWidth: 650 }} aria-label="indicator table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>{t('Code')}</TableCell>
                                                    <TableCell>{t('Description')}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {standard.adminEvaluationIndicators.map((indicator) => (
                                                    <TableRow
                                                      key={indicator.code}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {indicator.code}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {indicator.description}
                                                        </TableCell>
                                                    </TableRow>))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                </Box>
            </BasePathProvider>
        </Box>
    )
}
